import { render } from "./Journals.vue?vue&type=template&id=1094954a&scoped=true"
import script from "./Journals.vue?vue&type=script&lang=js"
export * from "./Journals.vue?vue&type=script&lang=js"

import "./Journals.vue?vue&type=style&index=0&id=1094954a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1094954a"]])

export default __exports__